module.exports = "<div class=\"panel-toggle panel-color\" ng-class=\"{\n    'toggle-open': $ctrl.isPaneOpen(),\n    'toggle-close': !$ctrl.isPaneOpen(),\n    'panel-color-2': $ctrl.panel === 'constructor'}\"><a ng-show=\"!$ctrl.isPaneOpen()\" title=\"{{:: 'Открыть панель' | gettext }}\" ng-click=\"$ctrl.switchPanel()\"><span class=\"panel-close\"><i class=\"icon-plus-1\"></i></span> </a><a ng-show=\"$ctrl.isPaneOpen()\" title=\"{{:: 'Закрыть панель' | gettext }}\" ng-click=\"$ctrl.switchPanel()\"><span class=\"panel-close\"><i class=\"icon-cancel\"></i></span></a></div>"


//////////////////
// WEBPACK FOOTER
// ./src/layout/sidebar-toggle.component.html
// module id = 1029
// module chunks = 0